module.exports = __webpack_public_path__ + "static/media/logo2.72ce2d00.png";